import { render, staticRenderFns } from "./payment-info-main.vue?vue&type=template&id=307cdd6b&scoped=true&"
import script from "./payment-info-main.vue?vue&type=script&lang=js&"
export * from "./payment-info-main.vue?vue&type=script&lang=js&"
import style0 from "./payment-info-main.vue?vue&type=style&index=0&id=307cdd6b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307cdd6b",
  null
  
)

export default component.exports